@charset "UTF-8";

/* libs/shared/src/lib/ui/notification-bell/notification-bell.component.scss */
.bell-btn {
  position: relative;
  align-items: center;
  background: none;
  border: 0;
  border-radius: var(--radius-md, 4px);
  color: var(--text-primary, #1f2937);
  cursor: pointer;
  display: inline-flex;
  height: 40px;
  justify-content: center;
  padding: 0;
  transition: background var(--transition-fast, 0.15s), color var(--transition-fast, 0.15s);
  width: 40px;
}
.bell-btn i {
  font-size: 20px;
}
.bell-btn:hover {
  background: var(--background-light, #f3f4f6);
  color: #000;
}
.bell-badge {
  position: absolute;
  top: 1px;
  right: 0;
  min-width: 16px;
  height: 16px;
  padding: 0 4px;
  border-radius: 999px;
  background: var(--error-red, #e23b2e);
  color: var(--background-white, #fff);
  font-size: 10.5px;
  font-weight: 600;
  line-height: 16px;
  text-align: center;
  box-shadow: 0 0 0 2px var(--background-white, #fff);
}
::ng-deep .header-ghost-menu.bell-menu.mat-mdc-menu-panel {
  width: 396px;
  max-width: none;
}
::ng-deep .header-ghost-menu.bell-menu.mat-mdc-menu-panel .mat-mdc-menu-content {
  padding: 0;
}
.nf-head {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 14px;
  border-bottom: 1px solid var(--background-border, #e5e7eb);
}
.nf-title {
  font-size: 13.5px;
  font-weight: 600;
  color: var(--text-primary, #1f2937);
}
.nf-count {
  font-size: 12px;
  color: var(--text-secondary, #6b7280);
}
.nf-counter {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.nf-badge {
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: 999px;
  background: var(--error-red, #e23b2e);
  color: var(--background-white, #fff);
  font-size: 11px;
  font-weight: 600;
  line-height: 18px;
  text-align: center;
  font-variant-numeric: tabular-nums;
}
.spacer {
  flex: 1;
}
.nf-link {
  background: none;
  border: 0;
  padding: 0;
  font: inherit;
  font-size: 12.5px;
  font-weight: 600;
  color: #1f5fc4;
  cursor: pointer;
  text-decoration: none;
}
.nf-link.muted {
  color: var(--text-secondary, #6b7280);
}
.nf-list {
  max-height: 392px;
  overflow-y: auto;
}
.nf-item {
  display: flex !important;
  gap: 11px;
  height: auto !important;
  padding: 12px 14px !important;
  line-height: 1.35 !important;
  border-bottom: 1px solid var(--background-lighter, #f1f2f4);
}
.nf-item:hover {
  background: #f9fafb !important;
}
.nf-item.unread {
  background: #f6f9ff !important;
}
.nf-item.unread:hover {
  background: #eef4ff !important;
}
.nf-ico {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  display: grid;
  place-items: center;
  flex: 0 0 26px;
}
.sev-info {
  background: #eef5ff;
  color: #1e4fa3;
}
.sev-warning {
  background: #fbf2dd;
  color: #a9761a;
}
.sev-error {
  background: #fdecea;
  color: #c0281c;
}
.nf-mid {
  min-width: 0;
  flex: 1;
  display: flex;
  flex-direction: column;
}
.nf-sub {
  font-size: 13px;
  font-weight: 600;
  color: var(--text-primary, #1f2937);
  line-height: 1.35;
  white-space: normal;
}
.nf-meta {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
  font-size: 11.5px;
  color: var(--text-light, #9ca3af);
  margin-top: 3px;
  white-space: normal;
}
.nf-meta .dot {
  width: 3px;
  height: 3px;
  border-radius: 50%;
  background: #cbd0d8;
  flex: 0 0 3px;
}
.nf-when {
  white-space: nowrap;
}
.nf-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: var(--error-red, #e23b2e);
  flex: 0 0 7px;
  align-self: flex-start;
  margin-top: 8px;
}
.nf-foot {
  display: flex;
  justify-content: space-between;
  padding: 10px 14px;
  background: var(--background-light, #fafbfc);
}
.nf-loading {
  align-items: center;
  display: flex;
  gap: 9px;
  justify-content: center;
  padding: 26px 14px;
  font-size: 12.5px;
  color: var(--text-light, #9ca3af);
  border-bottom: 1px solid var(--background-lighter, #f1f2f4);
}
.nf-empty {
  padding: 34px 14px;
  text-align: center;
  font-size: 13px;
  color: var(--text-light, #9ca3af);
}
/*# sourceMappingURL=notification-bell.component.css.map */
